export default {
  // Главный hero-блок на главной странице
  title_1: 'Международная платформа оценки недвижимости',
  title_2: 'Найдите недвижимость по цене ниже рынка',
  lead_1: 'Оценка, прогноз и сравнение объектов при помощи ИИ — всё в одном месте',
  lead_2: 'Современные алгоритмы: линейная регрессия, случайный лес, нейросеть',
  lead_3: 'Для инвесторов, застройщиков, агентств и продавцов недвижимости',
  login_btn: 'Войти',

  // Заголовки для hero других страниц
  title_property: 'Объект недвижимости',
  title_properties: 'Каталог недвижимости',
  title_developer: 'Профиль застройщика',
  title_developers: 'Все застройщики',
  title_agency: 'Профиль агентства',
  title_agencies: 'Агентства недвижимости',
  title_news: 'Новости и аналитика',
  title_news_item: 'Детали новости',
  title_residential_complex: 'Жилой комплекс',
  title_district: 'Информация о районе',
  title_statistics: 'Статистика рынка',
  title_about: 'О проекте Estimator24',

  // Хлебные крошки
  breadcrumbs: {
    home: 'Главная',
    properties: 'Все объекты',
    developers: 'Застройщики',
    agencies: 'Агентства',
    news: 'Новости',
    statistics: 'Статистика',
    about: 'О проекте'
  }
}
